/**
 * @param {number} amount
 * @param {number} interestRate
 * @param {number} fee
 * @param {number} terms
 * @returns {{total: *, monthly: *}}
 */
function calculateDebtRegistryRepaymentLoan ({ amount, interestRate, fee, terms } = {}) {
  function monthly (i, n, p, r) {
    return total(i, n, p, r) / r
  }

  function total (i, n, p, r) {
    return ((((i * (parseFloat(n) / 100)) / 12) * r) + i + (parseFloat(p) * r))
  }

  return {
    total: total(amount, interestRate, fee, terms) || 0,
    monthly: monthly(amount, interestRate, fee, terms) || 0
  }
}

module.exports = { calculateDebtRegistryRepaymentLoan }
